angular.module('shared').filter('decodeURIComponent', function () {
    return window.decodeURIComponent;
});
/**
 * Convert array of text to a text sring like 1 and 2 | 1,2 and 3 | 1,2,3...
 */
angular.module('shared').filter('array2Text', function () {
    return function (inputValue) {        
        // test is array
        if (inputValue.length) {
            if (inputValue.length === 0) { return ''; }
            if (inputValue.length === 1) { return inputValue[0]; }
            if (inputValue.length === 2) { return `${inputValue[0]} and ${inputValue[1]}`; }
            if (inputValue.length === 3) { return `${inputValue[0]}, ${inputValue[1]} and  ${inputValue[2]}`; }
            if (inputValue.length > 3 ) { return `${inputValue[0]}, ${inputValue[1]}, ${inputValue[2]}...`; }        
        }
    };
});